import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import styles from './svgIcon.scss';

export function SvgIcon (props) {
    const {
        children,
        className,
        viewBox,
        preserveAspectRatio,
        width,
        height,
        fill,
    } = props;

    const dimensionsStyles = (width && height) ? { width, height } : null;

    return (
        <svg
            styleName="wrapper"
            className={className}
            viewBox={viewBox}
            preserveAspectRatio={preserveAspectRatio}
            fill={fill}
            {...(dimensionsStyles ? { style: dimensionsStyles } : {})}
        >
            {children}
        </svg>
    );
}

SvgIcon.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    viewBox: PropTypes.string,
    preserveAspectRatio: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    fill: PropTypes.string,
};

export default CSSModules(SvgIcon, styles);
